import { Avatar } from '@sravni/react-design-system/lib/Avatar';
import { Card } from '@sravni/react-design-system/lib/Card';
import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Heading, Text } from '@sravni/react-design-system/lib/Typography';

export interface AdvantageCardMobileProps {
  title: string;
  icon: React.ReactNode;
  desc: string;
}

export const AdvantageCardMobile = ({ title, icon, desc }: AdvantageCardMobileProps) => (
  <Card key={title} size={16} color="dark">
    <Space align="center" size={12}>
      {icon && (
        <Avatar style={{ backgroundColor: 'var(--color-L100)' }}>
          <Icon icon={icon} color="green" />
        </Avatar>
      )}
      <Space direction="vertical" size={4}>
        <Heading level={5}>{title}</Heading>
        <Text size={14} className="whitespace-pre-line">
          {desc}
        </Text>
      </Space>
    </Space>
  </Card>
);
